import React, { createContext, useContext, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

// Interface for the context value
interface LanguageContextValue {
  isArabic: boolean;
}

// Create the language context
const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);

// Props for the provider
interface LanguageProviderProps {
  children: ReactNode;
}

// The provider component
export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const language = useSelector((state: RootState) => state.language.currentLanguage);
  
  // Only track if Arabic is selected, without changing direction
  const isArabic = language === 'arabic';

  return (
    <LanguageContext.Provider value={{ isArabic }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook to use the language context
export const useLanguageContext = (): LanguageContextValue => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguageContext must be used within a LanguageProvider');
  }
  return context;
}; 